import BaseInput from 'src/components/Inputs/BaseInput.vue';
import BaseDropdown from 'src/components/BaseDropdown.vue';
import Card from 'src/components/Cards/Card.vue';
import BaseButton from 'src/components/BaseButton.vue';
import BaseCheckbox from 'src/components/Inputs/BaseCheckbox.vue';
import BaseTable from "@/components/BaseTable";
import LoadingPanel from 'src/components/LoadingPanel'
import Modal from 'src/components/Modal'
import BaseRadio from 'src/components/Inputs/BaseRadio';
import BaseDrawer from 'src/components/BaseDrawer.vue';
import BaseAlertDialog from 'src/components/BaseAlertDialog.vue';
import BaseDateNavigator from 'src/components/BaseDateNavigator.vue';
import BaseRangeSelector from 'src/components/BaseRangeSelector.vue';
import BaseDateRangePicker from 'src/components/BaseDateRangePicker.vue';
import DrawerSection from 'src/components/DrawerSection.vue';
import FormSection from 'src/components/FormSection.vue';
import CollapsibleSection from 'src/pages/Bookings/BookinSiteSettings/components/shared/CollapsibleSection.vue';
import SegmentedToggle from 'src/components/SegmentedToggle.vue';
import DataTable from 'src/components/DataTable.vue';
import FilterBar from 'src/components/FilterBar.vue';
import SavedViewsMenu from 'src/components/SavedViewsMenu.vue';
import CustomFieldLinkCards from 'src/components/CustomFieldLinkCards.vue';
import ValuePeriodInput from 'src/components/Inputs/ValuePeriodInput.vue';
import MoneyInput from 'src/components/Inputs/MoneyInput.vue';
import PercentInput from 'src/components/Inputs/PercentInput.vue';
import BaseTextarea from 'src/components/Inputs/BaseTextarea.vue';
import CompanyUserPicker from 'src/components/Inputs/CompanyUserPicker.vue';
import InfoHint from 'src/components/InfoHint.vue';
import SaveStatus from 'src/components/SaveStatus.vue';
import CodeChip from 'src/components/CodeChip.vue';
import RatingDisplay from 'src/components/RatingDisplay.vue';
import RatingInput from 'src/components/RatingInput.vue';
import TagPicker from 'src/components/TagPicker.vue';
import CustomMessageFields from 'src/components/CustomMessageFields.vue';
import SlotPricingEditor from 'src/components/SlotPricingEditor.vue';
import DurationPills from 'src/components/DurationPills.vue';
import PricingCategoriesEditor from 'src/components/PricingCategoriesEditor.vue';
import RangeInput from 'src/components/Inputs/RangeInput.vue';
import BadgeDropdown from 'src/components/BadgeDropdown.vue';
import CustomFieldResponseRenderer from 'src/components/CustomFields/CustomFieldResponseRenderer.vue';
import CustomFieldSourceBadge from 'src/components/CustomFields/CustomFieldSourceBadge.vue';
import UtmAttribution from 'src/components/UtmAttribution.vue';
import AppendModeBanner from 'src/components/AppendModeBanner.vue';
import WaiverSignature from 'src/components/Waivers/WaiverSignature.vue';
import WaiverPdfDocument from 'src/components/Waivers/WaiverPdfDocument.vue';

import { Input, InputNumber, Tooltip, Popover, Select, Option, OptionGroup, DatePicker, Switch, Radio, RadioGroup, Image, InfiniteScroll } from 'element-ui';
import { foldDiacritics } from '@/util/search';

// Make every `filterable` el-select accent-insensitive, app-wide.
// Element UI's stock option filter (packages/select/src/option.vue `queryChange`)
// matches the label with a case-insensitive regex — it folds case but not
// diacritics, so "emile" never matches "Émile". Overriding the one shared
// Option component here fixes all filterable selects at once, including any
// added later, with no per-component filter-method. Selects that set their own
// :filter-method are unaffected (el-select calls that instead of queryChange).
if (Option.methods && Option.methods.queryChange && !Option.__accentInsensitivePatched) {
  Option.methods.queryChange = function (query) {
    this.visible = foldDiacritics(this.currentLabel).indexOf(foldDiacritics(query)) > -1 || this.created;
    if (!this.visible) {
      this.select.filteredOptionsCount--;
    }
  };
  // Flag lives on the component object, NOT in `methods` — Vue dev-mode
  // validates everything in `methods` is a function and warns on this boolean.
  Option.__accentInsensitivePatched = true;
}
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(Card.name, Card);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseTable.name, BaseTable);
    Vue.component(LoadingPanel.name, LoadingPanel);
    Vue.component(Modal.name, Modal);
    Vue.component(BaseDrawer.name, BaseDrawer);
    Vue.component(BaseAlertDialog.name, BaseAlertDialog);
    Vue.component(BaseDateNavigator.name, BaseDateNavigator);
    Vue.component(BaseRangeSelector.name, BaseRangeSelector);
    Vue.component(BaseDateRangePicker.name, BaseDateRangePicker);
    Vue.component(DrawerSection.name, DrawerSection);
    Vue.component(FormSection.name, FormSection);
    Vue.component(CollapsibleSection.name, CollapsibleSection);
    Vue.component(SegmentedToggle.name, SegmentedToggle);
    Vue.component(FilterBar.name, FilterBar);
    Vue.component(DataTable.name, DataTable);
    Vue.component(SavedViewsMenu.name, SavedViewsMenu);
    Vue.component(CustomFieldLinkCards.name, CustomFieldLinkCards);
    Vue.component(ValuePeriodInput.name, ValuePeriodInput);
    Vue.component(MoneyInput.name, MoneyInput);
    Vue.component(PercentInput.name, PercentInput);
    Vue.component(BaseTextarea.name, BaseTextarea);
    Vue.component(CompanyUserPicker.name, CompanyUserPicker);
    Vue.component(InfoHint.name, InfoHint);
    Vue.component(SaveStatus.name, SaveStatus);
    Vue.component(CodeChip.name, CodeChip);
    Vue.component(RatingDisplay.name, RatingDisplay);
    Vue.component(RatingInput.name, RatingInput);
    Vue.component(TagPicker.name, TagPicker);
    Vue.component(CustomMessageFields.name, CustomMessageFields);
    Vue.component(SlotPricingEditor.name, SlotPricingEditor);
    Vue.component(DurationPills.name, DurationPills);
    Vue.component(PricingCategoriesEditor.name, PricingCategoriesEditor);
    Vue.component(RangeInput.name, RangeInput);
    Vue.component(BadgeDropdown.name, BadgeDropdown);
    Vue.component(CustomFieldResponseRenderer.name, CustomFieldResponseRenderer);
    Vue.component(CustomFieldSourceBadge.name, CustomFieldSourceBadge);
    Vue.component(UtmAttribution.name, UtmAttribution);
    Vue.component(AppendModeBanner.name, AppendModeBanner);
    Vue.component(WaiverSignature.name, WaiverSignature);
    Vue.component(WaiverPdfDocument.name, WaiverPdfDocument);
    Vue.component(Input.name, Input);
    Vue.component(InputNumber.name, InputNumber);
    Vue.use(Tooltip);
    Vue.use(Popover);
    Vue.use(Image);
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(OptionGroup);
    Vue.use(DatePicker);
    Vue.use(Switch);
    Vue.use(Radio);
    Vue.use(RadioGroup);
    Vue.use(InfiniteScroll);
  }
};

export default GlobalComponents;
